var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',[_c('li',[_c('router-link',{attrs:{"to":{ name: 'CreateTask' }}},[_c('b-icon',{attrs:{"icon":"call-merge"}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('createTask')))])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }